export default "__VITE_ASSET__Cg7K6iUu__"